module.exports = __webpack_public_path__ + "static/media/tablet.2f4d4e95.webp";